import { InjectionToken } from '@angular/core';

export const PRIZM_STORE_ITEM = new InjectionToken<any>('get item for store');
